<ng-template #modalContentTemplate>
  <p class="confirmation-modal__body">
    {{ 'configurator.leavePageModal.text' | cxTranslate }}
  </p>
  <ui5-bar class="confirmation-modal__footer" data-sap-ui-fastnavgroup="true">
    <udex-button design="Emphasized" size="Large" slot="startContent" (click)="onContinue()" id="continueButton">
      {{ 'configurator.leavePageModal.continueButton' | cxTranslate }}
    </udex-button>
    <udex-button design="Default" size="Large" slot="startContent" (click)="onCancel()" id="cancelButton">
      {{ 'configurator.leavePageModal.cancelButton' | cxTranslate }}
    </udex-button>
  </ui5-bar>
</ng-template>
